import slugify from 'slugify';

export function convertToSlug(value) {
  return slugify(value, {
    lower: true,
    strict: true
  }) || '';
}